import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { v_DispatchBus } from '@app/cp/shared/models/v_DispatchBus';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import * as _ from 'lodash';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DashboardWidgetService } from '@app/cp/shared/services/dashboardWidget.service';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { SelectionEvent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'cp-quote-summary-grid',
  templateUrl: './quote-summary-grid.component.html',
  styleUrls: ['./quote-summary-grid.component.scss']
})
export class QuoteSummaryGridComponent extends BaseGridComponent<v_DispatchBus, null>  {
    rowSelected(e: SelectionEvent) {

    }
    searchParam: WidgetSearch;
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_data: DispatchesService, private svc_dashWidget: DashboardWidgetService, private svc_dashboard: DashboardService) {
        super(globals, featureFlagService);
    }

    @Input() inputData: any;
    @Input() dataFilter: WidgetSearch;
    @Input() changeCheck: string;
    @Output() openRequest = new EventEmitter<any>();

    loaderState: boolean = true;

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public contentTypes = WindowContents;

    initialLoad: boolean = true;
    setup(data: any) {

    }
    ngOnInit() {
        this.setup(this.dataFilter);
        this.initialLoad = false;
    }

    ngOnChanges() {
        this.loaderState = true;
        if (!this.initialLoad) {
            this.setup(this.dataFilter);
        }
    }

    showDetailsPopup(id: string, type: number) {
        this.svc_dashboard.openDQOIPopup(id, type);
    }

    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }
}
